import React from 'react';
import {useHistory} from 'react-router-dom';
import '../style/styles.scss';


export default () => {

  let history = useHistory();

  const signupHandler = () => {
    console.log("In signupHandler XXX");
    history.push('/signup');
  }

  return (
    <div>
      <button name="getaccount" onClick={signupHandler}>Signup</button>
    </div>
  );

};
